import { useTranslation } from "react-i18next";

export default function GoalEmptyState() {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      <h3 className="mt-2 text-sm font-semibold text-gray-900">{t("No goals")}</h3>
      <p className="mt-1 text-sm text-gray-500">
        {t(
          "Goals are a great way to track progress and ensure that you and your team consistently meet the targets that keep your business running."
        )}
      </p>
    </div>
  );
}
